import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BookingModal from '../../components/feature/BookingModal';
import { SEO } from '../../utils/seo';

export default function SUVCarPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [galleryType, setGalleryType] = useState<'exterior' | 'interior'>('exterior');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const vehicles = [
    {
      id: 1,
      name: '현대 팰리세이드4륜 캘리그래피',
      price: '250,000',
      fuel: '가솔린(26년식)',
      seats: '7인승',
      transmission: '자동 2채널블박 풀옵션',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/838226379811b1278171a584e9964679.jpeg',
      exteriorImages: [
        'https://public.readdy.ai/ai/img_res/431eec452cbb4571a40141c77e5f547d.jpg',
        'https://readdy.ai/api/search-image?query=Hyundai%20Palisade%20large%20luxury%20SUV%20exterior%20side%20profile%20view%20in%20elegant%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20imposing%20proportions%20and%20premium%20character&width=1200&height=800&seq=suv-palisade-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Palisade%20large%20luxury%20SUV%20exterior%20rear%20three-quarter%20view%20in%20elegant%20white%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20vertical%20LED%20tail%20lamps%20and%20sophisticated%20rear%20design&width=1200&height=800&seq=suv-palisade-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Palisade%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20luxurious%20black%20Nappa%20leather%20upholstery%2C%20large%20touchscreen%20display%2C%20digital%20instrument%20cluster%2C%20premium%20materials%2C%20three-row%20seating%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-palisade-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Palisade%20SUV%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20push-button%20gear%20selector%2C%20smart%20key%20system%2C%20ambient%20lighting%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-palisade-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Palisade%20SUV%20interior%20second%20and%20third%20row%20seats%20view%20with%20spacious%20black%20leather%20seating%20for%20seven%20passengers%2C%20premium%20comfort%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20generous%20space&width=1200&height=800&seq=suv-palisade-int-3&orientation=landscape',
      ],
    },
    {
      id: 2,
      name: '기아 쏘렌토4륜 노블레스',
      price: '200,000',
      fuel: '하이브리드(24년식)',
      seats: '7인승',
      transmission: '자동 2채널블박',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/15730e99294f0b7595fcb536063d9de1.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20midsize%20SUV%20exterior%20front%20three-quarter%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20tiger%20nose%20grille%20and%20modern%20design&width=1200&height=800&seq=suv-sorento-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20midsize%20SUV%20exterior%20side%20profile%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20athletic%20proportions%20and%20family-friendly%20character&width=1200&height=800&seq=suv-sorento-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20midsize%20SUV%20exterior%20rear%20three-quarter%20view%20in%20sophisticated%20gray%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20modern%20LED%20tail%20lamps%20and%20refined%20rear%20styling&width=1200&height=800&seq=suv-sorento-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20upholstery%2C%20dual%20touchscreen%20displays%2C%20digital%20cockpit%2C%20quality%20materials%2C%20three-row%20seating%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-sorento-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20SUV%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-sorento-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sorento%20SUV%20interior%20second%20and%20third%20row%20seats%20view%20with%20comfortable%20black%20leather%20seating%20for%20seven%20passengers%2C%20practical%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20versatile%20space&width=1200&height=800&seq=suv-sorento-int-3&orientation=landscape',
      ],
    },
    {
      id: 3,
      name: '현대 싼타페4륜 프레스트지',
      price: '200,000',
      fuel: '하이브리드(23년식)',
      seats: '7인승',
      transmission: '자동 2채널블박',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/008c8503a7f027b3acb1642bd7d59351.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20midsize%20SUV%20exterior%20front%20three-quarter%20view%20in%20modern%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20parametric%20jewel%20grille%20and%20rugged%20design&width=1200&height=800&seq=suv-santafe-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20midsize%20SUV%20exterior%20side%20profile%20view%20in%20modern%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20muscular%20proportions%20and%20adventurous%20character&width=1200&height=800&seq=suv-santafe-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20midsize%20SUV%20exterior%20rear%20three-quarter%20view%20in%20modern%20silver%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20vertical%20LED%20tail%20lamps%20and%20robust%20rear%20design&width=1200&height=800&seq=suv-santafe-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20premium%20black%20leather%20upholstery%2C%20curved%20panoramic%20display%2C%20digital%20cockpit%2C%20modern%20materials%2C%20three-row%20seating%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-santafe-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20SUV%20interior%20center%20console%20close-up%20view%20with%20premium%20materials%2C%20electronic%20gear%20selector%2C%20ambient%20lighting%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-santafe-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Santa%20Fe%20SUV%20interior%20second%20and%20third%20row%20seats%20view%20with%20spacious%20black%20leather%20seating%20for%20seven%20passengers%2C%20versatile%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20family-friendly%20space&width=1200&height=800&seq=suv-santafe-int-3&orientation=landscape',
      ],
    },
    {
      id: 4,
      name: '기아 스포티지 프레스트지',
      price: '140,000',
      fuel: '가솔린(23년식)',
      seats: '5인승',
      transmission: '자동 2채널블박',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3010cdef74e6ad822eac1bfd85f296fe.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20compact%20SUV%20exterior%20front%20three-quarter%20view%20in%20vibrant%20red%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20tiger%20nose%20design%20and%20dynamic%20styling&width=1200&height=800&seq=suv-sportage-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20compact%20SUV%20exterior%20side%20profile%20view%20in%20vibrant%20red%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20sporty%20proportions%20and%20modern%20character&width=1200&height=800&seq=suv-sportage-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20compact%20SUV%20exterior%20rear%20three-quarter%20view%20in%20vibrant%20red%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20boomerang%20LED%20tail%20lamps%20and%20sporty%20rear%20design&width=1200&height=800&seq=suv-sportage-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20cloth%20upholstery%2C%20curved%20panoramic%20display%2C%20digital%20cockpit%2C%20quality%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-sportage-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20SUV%20interior%20center%20console%20close-up%20view%20with%20modern%20materials%2C%20electronic%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-sportage-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Sportage%20SUV%20interior%20rear%20passenger%20seats%20view%20with%20comfortable%20black%20seating%2C%20practical%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20versatile%20space&width=1200&height=800&seq=suv-sportage-int-3&orientation=landscape',
      ],
    },
    {
      id: 5,
      name: '기아 셀토스 프레스트지',
      price: '100,000',
      fuel: '가솔린(23년식)',
      seats: '5인승',
      transmission: '자동 2채널블박',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/cc882304e1e61a2d704260022c1c0554.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20compact%20SUV%20exterior%20front%20three-quarter%20view%20in%20modern%20orange%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20bold%20tiger%20nose%20grille%20and%20youthful%20design&width=1200&height=800&seq=suv-seltos-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20compact%20SUV%20exterior%20side%20profile%20view%20in%20modern%20orange%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20compact%20proportions%20and%20urban%20character&width=1200&height=800&seq=suv-seltos-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20compact%20SUV%20exterior%20rear%20three-quarter%20view%20in%20modern%20orange%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20distinctive%20connected%20LED%20tail%20lamps%20and%20modern%20rear%20styling&width=1200&height=800&seq=suv-seltos-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20cloth%20upholstery%2C%20touchscreen%20display%2C%20digital%20instrument%20cluster%2C%20contemporary%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-seltos-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20SUV%20interior%20center%20console%20close-up%20view%20with%20modern%20materials%2C%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-seltos-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Seltos%20SUV%20interior%20rear%20passenger%20seats%20view%20with%20comfortable%20black%20seating%2C%20practical%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20efficient%20use%20of%20space&width=1200&height=800&seq=suv-seltos-int-3&orientation=landscape',
      ],
    },
    {
      id: 6,
      name: '현대 코나1.6 인스퍼레이션',
      price: '100,000',
      fuel: '가솔린(23년식)',
      seats: '5인승',
      transmission: '자동 2채널블박 풀옵션',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/20a3e7f81df269c480d6fc0bace9b971.png',
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20compact%20SUV%20exterior%20front%20three-quarter%20view%20in%20vibrant%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20highlighting%20distinctive%20cascading%20grille%20and%20bold%20design&width=1200&height=800&seq=suv-kona-ext-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20compact%20SUV%20exterior%20side%20profile%20view%20in%20vibrant%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20emphasizing%20compact%20proportions%20and%20playful%20character&width=1200&height=800&seq=suv-kona-ext-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20compact%20SUV%20exterior%20rear%20three-quarter%20view%20in%20vibrant%20blue%20color%20on%20professional%20automotive%20photography%20background%20with%20clean%20minimalist%20gradient%20from%20soft%20sky%20blue%20to%20pure%20white%2C%20studio%20lighting%20showcasing%20unique%20split%20LED%20tail%20lamps%20and%20distinctive%20rear%20design&width=1200&height=800&seq=suv-kona-ext-3&orientation=landscape',
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20SUV%20interior%20dashboard%20and%20front%20seats%20view%20with%20modern%20black%20cloth%20upholstery%2C%20touchscreen%20infotainment%20display%2C%20digital%20instrument%20cluster%2C%20contemporary%20materials%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-kona-int-1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20SUV%20interior%20center%20console%20close-up%20view%20with%20modern%20materials%2C%20gear%20selector%2C%20smart%20key%20system%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting&width=1200&height=800&seq=suv-kona-int-2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Kona%20SUV%20interior%20rear%20passenger%20seats%20view%20with%20comfortable%20black%20seating%2C%20practical%20features%2C%20professional%20automotive%20interior%20photography%20with%20soft%20even%20lighting%20showing%20compact%20yet%20functional%20space&width=1200&height=800&seq=suv-kona-int-3&orientation=landscape',
      ],
    },
  ];

  const openGallery = (vehicle: any, type: 'exterior' | 'interior') => {
    setSelectedVehicle(vehicle);
    setGalleryType(type);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedVehicle(null);
  };

  const getCurrentImages = () => {
    if (!selectedVehicle) return [];
    return galleryType === 'exterior' ? selectedVehicle.exteriorImages : selectedVehicle.interiorImages;
  };

  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "대전SUV렌트카",
        "description": "넓은 공간과 높은 시야로 편안한 여행을 즐기세요. 가족 여행, 캠핑, 레저 활동에 최적화된 다목적 차량입니다.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/suv-car`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "대전렌트카",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        }
      },
      {
        "@type": "ItemList",
        "name": "대전 SUV 렌트 차량 목록",
        "description": "대전렌트카 SUV 렌트 차량 목록",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/suv-car`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "현대 팰리세이드4륜 캘리그래피",
            "description": "가솔린 26년식 7인승 대형 SUV, 1일 렌트 ₩250,000"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "기아 쏘렌토4륜 노블레스",
            "description": "하이브리드 24년식 7인승 중형 SUV, 1일 렌트 ₩200,000"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "현대 싼타페4륜 프레스트지",
            "description": "하이브리드 23년식 7인승 중형 SUV, 1일 렌트 ₩200,000"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "기아 스포티지 프레스트지",
            "description": "가솔린 23년식 5인승 소형 SUV, 1일 렌트 ₩140,000"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "기아 셀토스 프레스트지",
            "description": "가솔린 23년식 5인승 소형 SUV, 1일 렌트 ₩100,000"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "현대 코나1.6 인스퍼레이션",
            "description": "가솔린 23년식 5인승 소형 SUV 풀옵션, 1일 렌트 ₩100,000"
          }
        ]
      }
    ]
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <SEO
          title="대전SUV렌트카 - 넓고 편안한 SUV 렌트 | 대전렌트카"
          description="넓은 공간과 높은 시야로 편안한 여행을 즐기세요. 가족 여행, 캠핑, 레저 활동에 최적화된 다목적 차량입니다. 24시간 예약 가능."
          keywords="대전SUV렌트카, 대전SUV대여, 가족여행렌트카, 캠핑렌트카, 7인승렌트카"
          canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/suv-car`}
          schema={schema}
        />
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="mb-12">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-5xl font-bold text-gray-900">대전SUV렌트카</h1>
                <a 
                  href="tel:010-5437-1535"
                  className="flex items-center gap-3 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">010-5437-1535</span>
                </a>
              </div>
              <p className="text-lg text-gray-600">
                넓은 공간과 높은 시야로 편안한 여행을 즐기세요. 
                가족 여행, 캠핑, 레저 활동에 최적화된 다목적 차량입니다.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="h-64 bg-gradient-to-b from-sky-50 to-white p-6">
                    <img
                      src={vehicle.image}
                      alt={vehicle.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                    <p className="text-3xl font-extrabold text-primary mb-1">₩{vehicle.price}</p>
                    <p className="text-sm text-gray-500 mb-4">자차별도</p>
                    <div className="grid grid-cols-2 gap-3 mb-6 text-sm text-gray-600">
                      <div className="flex items-center gap-2">
                        <i className="ri-gas-station-line text-primary"></i>
                        <span>{vehicle.fuel}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-user-line text-primary"></i>
                        <span>{vehicle.seats}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-settings-3-line text-primary"></i>
                        <span>{vehicle.transmission}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <i className="ri-calendar-line text-primary"></i>
                        <span>1일 기준</span>
                      </div>
                    </div>

                    {/* 이미지 갤러리 버튼 */}
                    <div className="flex gap-2 mb-4">
                      <button
                        onClick={() => openGallery(vehicle, 'exterior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-image-line mr-1"></i>
                        외부사진
                      </button>
                      <button
                        onClick={() => openGallery(vehicle, 'interior')}
                        className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-steering-2-line mr-1"></i>
                        내부사진
                      </button>
                    </div>

                    <a 
                      href="tel:010-5437-1535"
                      className="w-full bg-gray-900 text-white py-3 rounded-xl font-medium hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap block text-center"
                    >
                      지금 예약하기
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>
        <Footer />
        <BookingModal 
          isOpen={isBookingModalOpen} 
          onClose={() => setIsBookingModalOpen(false)} 
        />

        {/* 이미지 갤러리 모달 */}
        {isGalleryOpen && selectedVehicle && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-4xl"></i>
            </button>

            <div className="w-full max-w-6xl">
              {/* 탭 */}
              <div className="flex justify-center gap-4 mb-6">
                <button
                  onClick={() => { setGalleryType('exterior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'exterior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  외부사진
                </button>
                <button
                  onClick={() => { setGalleryType('interior'); setCurrentImageIndex(0); }}
                  className={`px-6 py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    galleryType === 'interior'
                      ? 'bg-primary text-white'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  내부사진
                </button>
              </div>

              {/* 메인 이미지 */}
              <div className="relative aspect-video bg-black rounded-lg overflow-hidden mb-4">
                <img
                  src={getCurrentImages()[currentImageIndex]}
                  alt={`${selectedVehicle.name} ${galleryType === 'exterior' ? '외부' : '내부'} ${currentImageIndex + 1}`}
                  className="w-full h-full object-contain"
                />
                
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>

              {/* 썸네일 */}
              <div className="flex justify-center gap-2">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentImageIndex(idx)}
                    className={`w-20 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                      idx === currentImageIndex ? 'border-primary' : 'border-transparent opacity-50 hover:opacity-100'
                    }`}
                  >
                    <img src={img} alt={`썸네일 ${idx + 1}`} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}